<br>
<h2 class="color-main"> <strong> NÚMERO DE COTIZACIÓN: #{{numeroCotizacion}} </strong> </h2>
<br>
<div class="row m-0">
    <div class="table-responsive" *ngFor="let basic of listLineaTable; let i = index;">
        <table class="table table-striped ">
            <thead style="background-color: #0372b9">
                <th colspan="20">
                    <table>
                        <tr>
                            <td style="width: 50%;">
                                <label style="color: white;"> {{basic.businessName}} </label>
                            </td>
                            <td>
                                <label style="color: white;"> </label>
                            </td>
                            <td>
                                <label style="color: white;"> </label>
                            </td>
                            <td style="justify-items: center;">
                                <label style="color: white;cursor: pointer;"
                                    *ngIf="(interactionMenu.index === i && !interactionMenu.action) || interactionMenu.index !== i"
                                    (click)="showItems(i)">
                                    <mat-icon aria-label="Example home icon">navigate_next
                                    </mat-icon>
                                </label>
                                <label style="color: white;cursor: pointer;"
                                    *ngIf="interactionMenu.index === i && interactionMenu.action"
                                    (click)="showItems(i)">
                                    <mat-icon aria-label="Example home icon">
                                        expand_more</mat-icon>
                                </label>
                            </td>
                        </tr>
                    </table>
                </th>
            </thead>
            <div *ngIf="interactionMenu.index === i && interactionMenu.action">
                <div class="row m-0" style="text-align: center;">
                    <div class="col-md-6">
                        <table>
                            <tr>
                                <td style="text-align: center;">
                                    <h3 class="color-main"> {{basic.typeLine}}</h3>
                                    <label>Tipo de línea</label>
                                </td>
                                <td style="text-align: center;" class="border-left">
                                    <h3 class="color-main"> {{basic.planType}}</h3>
                                    <label>Tipo de plan</label>
                                </td>
                                <td style="text-align: center;" class="border-left">
                                    <h3 class="color-main"><img src="assets/imagenes/peso.png">
                                        ${{valorMoneda(basic.registrationFee)}}
                                    </h3>
                                    <label>Cuota de inscripción</label>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="col-md-6">
                        <table>
                            <tr>
                                <td style="text-align: center;" class="border-left">
                                    <h3 class="color-main"><img src="assets/imagenes/peso.png">
                                        ${{valorMoneda(basic.totalMonthlyFee)}}
                                    </h3>
                                    <label>Cuota mensual total</label>
                                </td>
                                <td style="text-align: center;" class="border-left">
                                    <img width="75px" src="{{imgPrograma}}">
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <br>
                <h1 class="col-md-12 color-main">
                    Detalle pago mensual
                </h1>
                <div class="col-md-12">
                    <table class="table table-striped">
                        <tbody>
                            <tr *ngFor="let item of basic.beneficiaryList; let i=index;">
                                <td>
                                    <label>
                                        {{i + 1}}
                                    </label>
                                </td>
                                <td>
                                    <label>
                                        {{item.beneficiaryName}}
                                    </label>
                                </td>
                                <td class="color-main">
                                    <label *ngIf="dataCampania.codigo_tipo_plan === 'F'">
                                        <strong>FAMILIAR: ${{
                                            valorMoneda( item.familyValue) }} </strong>
                                    </label>
                                </td>
                                <td class="color-main">
                                    <label>
                                        <strong>ASOCIADO: ${{ valorMoneda( dataCampania.codigo_tipo_plan === 'F' ?
                                            item.associatedValue
                                            :
                                            item.familyValue) }} </strong>
                                    </label>
                                </td>
                                <td style="text-align: center;">
                                    <img width="75px" src="{{item.imgProgram}}">
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </table>
    </div>
</div>
<br>
<h1 class="color-main">
    Valor pago anticipado
</h1>
<div class="row m-0">
    <div class="col-md-4">
        <table style="border-radius:20px" class="jumbotron">
            <tr>
                <td style="height: 30px;"></td>
            </tr>
            <tr>
                <td style="text-align: center;">
                    <h3 class="color-main"><strong>Meses</strong></h3>
                </td>
            </tr>
            <tr>
                <td style="color: transparent;">.</td>
            </tr>
            <tr *ngFor="let descueto of detalle_descuentos">
                <td style="text-align: center;">
                    <label>
                        <strong>{{descueto.cantidad_mes}} meses</strong>
                    </label>
                </td>
            </tr>
            <tr>
                <td style="height: 30px;"></td>
            </tr>
        </table>
    </div>
    <div class="col-md-4">

        <table style="border-radius:20px" class="jumbotron">
            <tr>
                <td style="height: 30px;"></td>
            </tr>
            <tr>
                <td colspan="2" style="text-align: center;">
                    <h3 class="color-main"><strong>Valor descuento pago anticipado</strong></h3>
                </td>
            </tr>
            <tr>
                <td style="text-align: center;" *ngIf="dataCampania.codigo_tipo_plan === 'F'">
                    <label>
                        <strong>Familiar</strong>
                    </label>

                </td>
                <td style="text-align: center;">
                    <label>
                        <strong>Asociado</strong>
                    </label>

                </td>
            </tr>
            <tr *ngFor="let descueto of detalle_descuentos">
                <td style="text-align: center;" *ngIf="dataCampania.codigo_tipo_plan === 'F'">
                    <label>
                        ${{this.valorMoneda(descueto.valor_descuento_familiar)}}
                    </label>
                </td>
                <td class="border-left" style="text-align: center;">
                    <label>
                        ${{this.valorMoneda(descueto.valor_descuento_asociado)}}
                    </label>
                </td>
            </tr>
            <tr>
                <td style="height: 30px;"></td>
            </tr>
        </table>
    </div>
    <div class="col-md-4">
        <table style="background-color: #0372b9;border-radius:20px" class="jumbotron">
            <tr>
                <td style="height: 30px;"></td>
            </tr>
            <tr>
                <td colspan="2" style="text-align: center">
                    <h3 style="color: white;" class="color-main">
                        <strong>
                            Valor a pagar anticipado
                        </strong>
                    </h3>
                </td>
            </tr>
            <tr>
                <td style="text-align: center;color: white;" *ngIf="dataCampania.codigo_tipo_plan === 'F'">
                    <label>
                        <strong>Familiar</strong>
                    </label>
                </td>
                <td style="text-align: center;color: white;">
                    <label>
                        <strong>Asociado</strong>
                    </label>
                </td>
            </tr>
            <tr *ngFor="let descueto of detalle_descuentos">
                <td style="text-align: center;color: white;" *ngIf="dataCampania.codigo_tipo_plan === 'F'">
                    <label>
                        ${{this.valorMoneda(descueto.valor_pago_anticipado_familiar)}}
                    </label>
                </td>
                <td class="border-left" style="text-align: center;color: white;">
                    <label>
                        ${{this.valorMoneda(descueto.valor_pago_anticipado_asociado)}}
                    </label>
                </td>
            </tr>
            <tr>
                <td style="height: 30px;"></td>
            </tr>
        </table>
    </div>
</div>
